import {
  ArrowRight,
  Upload,
  FileText,
  Keyboard,
  Calculator,
  Download,
  Coffee,
  Check,
  Clock,
} from "lucide-react";

export function Comparison() {
  return (
    <div className="mx-auto">
      <h1 className="text-xl md:text-3xl font-bold text-center mb-12">
        Grade Conversion Process Comparison
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
        {/* Manual Process */}
        <div className="border rounded-lg p-6 shadow-md">
          <h2 className="text-lg font-semibold mb-6 flex items-center">
            <Clock className="mr-2 text-gray-600" size={24} />
            Manual Process
          </h2>

          <div className="space-y-8">
            {[
              {
                icon: FileText,
                text: "Open PDF",
                description: "Manually open and review document",
              },
              {
                icon: Keyboard,
                text: "Enter grades",
                description: "Manually input each grade",
              },
              {
                icon: Calculator,
                text: "Convert",
                description: "Convert to US grading system",
              },
              {
                icon: Download,
                text: "Export",
                description: "Generate and download PDF",
              },
              {
                icon: ArrowRight,
                text: "Repeat",
                description: "Repeat for each transcript",
              },
            ].map((step, index) => (
              <div key={index} className="flex items-start">
                <div className="bg-gray-100 p-3 rounded-full mr-4">
                  <step.icon className="text-gray-700" size={20} />
                </div>
                <div>
                  <h3 className="font-medium text-base">{step.text}</h3>
                  <p className="text-gray-600 text-sm">{step.description}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-8 p-4 bg-gray-50 rounded-lg">
            <p className="text-gray-700 font-medium">
              ⏱️ Time-consuming process requiring manual intervention at each
              step
            </p>
          </div>
        </div>

        {/* AI Process */}
        <div className="border flex flex-col rounded-lg p-6 shadow-md border-primary/20 bg-primary/5">
          <h2 className="text-lg font-semibold mb-6 flex items-center text-primary">
            <Check className="mr-2" size={24} />
            AI-Powered Process
          </h2>

          <div className="space-y-8 flex-grow">
            {[
              {
                icon: Upload,
                text: "Upload",
                description: "Bulk upload multiple transcript PDFs at once",
              },
              {
                icon: Coffee,
                text: "Sip Coffee",
                description: "Relax while AI does the work",
              },
              {
                icon: Download,
                text: "Done",
                description: "PDF ready",
              },
            ].map((step, index) => (
              <div key={index} className="flex items-start">
                <div className="bg-primary/10 p-3 rounded-full mr-4">
                  <step.icon className="text-primary" size={20} />
                </div>
                <div>
                  <h3 className="font-medium text-base">{step.text}</h3>
                  <p className="text-gray-600 text-sm">{step.description}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-8 p-4 bg-primary/5 rounded-lg">
            <p className="text-primary font-medium space-x-2">
              ✨ Automated end-to-end process with minimal user intervention.
              Process multiple transcripts simultaneously with higher accuracy
            </p>
          </div>
        </div>
      </div>

      <div className="mt-12 p-6 bg-blue-50 rounded-lg">
        <h2 className="text-xl font-semibold mb-4">
          Why Choose AI-Powered Conversion?
        </h2>
        <ul className="space-y-2">
          <li className="flex items-start">
            <Check
              className="text-blue-600 mr-2 mt-1 flex-shrink-0"
              size={18}
            />
            <span>Up to 90% faster than traditional processing methods</span>
          </li>
          <li className="flex items-start">
            <Check
              className="text-blue-600 mr-2 mt-1 flex-shrink-0"
              size={18}
            />
            <span>Process multiple transcripts simultaneously</span>
          </li>
          <li className="flex items-start">
            <Check
              className="text-blue-600 mr-2 mt-1 flex-shrink-0"
              size={18}
            />
            <span>Consistent formatting and professional output</span>
          </li>
          <li className="flex items-start">
            <Check
              className="text-blue-600 mr-2 mt-1 flex-shrink-0"
              size={18}
            />
            <span>
              Focus on reviewing results rather than manual data entry
            </span>
          </li>
        </ul>
      </div>
    </div>
  );
}
